// extracted by mini-css-extract-plugin
export default {"component":"cCEJPy","mobile":"L8sPTc","label":"fZCHPS","top":"EcNw_E","imageWrap":"zGAYPG","info":"BaNDy4","title":"bDkye8","card":"k1_800"};